import { httpGet } from './httpGet';

export const segments = {
	get: httpGet
};
